import { useState, useCallback } from 'react'
import { GraphQLCampaignRepository } from '../../../infrastructure/graphql/CampaignRepositoryImpl'
import { useAuth0 } from '@auth0/auth0-react'
import { CampaignInput } from '../../../domain/entities/Campaign'

export function useUpdateCampaign() {
  const { getIdTokenClaims } = useAuth0()

  const [updating, setUpdating] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  const updateCampaign = useCallback(
    async (campaignId: string, input: CampaignInput) => {
      setUpdating(true)
      setError(null)
      try {
        const getToken = async () => (await getIdTokenClaims())?.__raw ?? ''
        const repo = new GraphQLCampaignRepository(getToken)
        const campaign = {
          ...input,
          id: campaignId,
        }
        const updated = await repo.update(campaign)
        return updated
      } catch (err: any) {
        setError(err)
        throw err
      } finally {
        setUpdating(false)
      }
    },
    [getIdTokenClaims]
  )

  return { updateCampaign, updating, error }
}
